// Enums
import { ContractStatesEnumeration } from 'containers/contract/enumerations/contract-states.enumeration';

const WRAPPED_STATES = [ContractStatesEnumeration.OTP];

export { WRAPPED_STATES };
